import { render, staticRenderFns } from "./EditaLoc.vue?vue&type=template&id=1d3022b7"
import script from "./EditaLoc.vue?vue&type=script&lang=js"
export * from "./EditaLoc.vue?vue&type=script&lang=js"
import style0 from "./EditaLoc.vue?vue&type=style&index=0&id=1d3022b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports